import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.adzanitech.my.id";
const SITE_NAME = "Efwan Rizaldi Portfolio";
const DEFAULT_IMAGE = "/preview.png";

interface SeoProps {
  title: string;
  description?: string;
  /** Route path WITHOUT leading domain, e.g. "/about" or "/artikel". Defaults to "/". */
  path?: string;
  image?: string;
  type?: "website" | "article";
  /** Optionally inject a JSON-LD object for rich results (e.g. Person, Article). */
  jsonLd?: Record<string, unknown> | Array<Record<string, unknown>>;
}

const Seo: React.FC<SeoProps> = ({
  title,
  description = "Portfolio of Efwan Rizaldi — Software Engineer specializing in frontend, Web3 & Blockchain. Open to remote / international opportunities.",
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
}) => {
  const url = `${SITE_URL}${path}`;
  const imageUrl = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {jsonLd ? (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      ) : null}
    </Helmet>
  );
};

export default Seo;
